import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Clock } from 'lucide-react';

const OperatingHours = () => {
  const { t } = useLanguage();

  return (
    <section className="bg-[#121212] py-12 animate-fade-in">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16">
          <div className="flex items-center gap-3">
            <Clock size={24} className="text-[#00FFD1]" />
            <h3 className="text-xl font-semibold text-white">{t('hoursTitle')}</h3>
          </div>
          
          <div className="flex flex-wrap items-center justify-center gap-8">
            <div className="text-center">
              <p className="text-white/60 text-sm mb-1">{t('hoursWeekday')}</p>
              <p className="text-white text-lg font-medium">{t('hoursTime1')}</p>
            </div>
            <div className="w-px h-10 bg-white/20 hidden md:block" />
            <div className="text-center">
              <p className="text-white/60 text-sm mb-1">{t('hoursWeekend')}</p>
              <p className="text-white text-lg font-medium">{t('hoursTime2')}</p>
            </div>
          </div>
          
          <p className="text-[#00FFD1] text-sm">{t('hoursNote')}</p>
        </div>
      </div>
    </section>
  );
};

export default OperatingHours;